// imports
import '../../web/assets/webfonts/webfonts.css'
import "../sass/styles.sass"

// base
import('./base/base.js').then((module) => {
  module.initBase()
})

// header navigation
if (document.querySelector('nav.site-header-navigation')) {
  import('./layout/header-navigation.js').then((module) => {
    module.initNavigation()
  })
}

/* ------------------------------
---------- Components -----------
------------------------------ */
// table of contents
if (document.querySelector('aside.sidebar-toc[data-id="scroll-observe"]')) {
  import('./components/toc-sidebar.js').then((module) => {
    // module.initCoursesSidebar()
    module.initTocSidebar()
  })
}

// video modal
if (document.getElementById('video-modal-trigger')) {
  import('./components/video-modal.js').then((module) => {
    module.initVideoModal()
  })
}

// booking modal
if (document.querySelector('button[data-id="booking-modal-trigger"]')) {
  import('./components/booking-modal.js').then((module) => {
    module.initBookingModal()
  })
}